// src/components/Admin/Scenes/SceneIframe.jsx
import React, { useEffect, useState } from "react";
import { MozillaHubRoomsApi, DidacticRoutesAPI } from "../../../../api"; 
import "./SceneIframe.scss"; // Opcional, para estilos

const mozillaHubRoomsApi = new MozillaHubRoomsApi();
const didacticRoutesAPI = new DidacticRoutesAPI();

export function SceneIframe({ accessToken, shortLink, fallbackUrl, routeId, scene }) {
  /**
   * shortLink -> el ID de la escena (p.e. "XzPMRv8")
   * fallbackUrl -> la url normal (p.e. "https://educa360.org/scenes/Gd3ex1t") en caso de no tener shortLink
   * routeId -> ID de la ruta didáctica para actualizar
   */ 

  const [iframeUrl, setIframeUrl] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadIframe = async () => {
      try {
        setLoading(true);
        setError(null);

        if (!shortLink) {
          // Si no hay shortLink, usamos fallbackUrl directamente
          setIframeUrl(fallbackUrl);
          if(routeId) {
            // Actualizar ruta con sceneactive = fallbackUrl
            await didacticRoutesAPI.updateDidacticRoute(accessToken, routeId, { sceneactive: fallbackUrl,
              sceneactive_Id: scene._id });
          }
          return;
        }
        console.log("Cargando sala ", scene);
        // Llamada a la API para cargar la sala con shortLink
        const result = await mozillaHubRoomsApi.LoadRoom(accessToken, shortLink);
        const finalUrl = `https://educa360.org/${result.room.id}?embed_token=${result.room.embedToken}`;
        setIframeUrl(finalUrl);
        if(routeId) {
          // Actualizar ruta con sceneactive = finalUrl
          await didacticRoutesAPI.updateDidacticRoute(accessToken, routeId, { 
            sceneactive: finalUrl,
            sceneactive_Id: scene._id,});
        }
      } catch (err) {
        console.error("Error cargando la sala:", err);
        setError(err.message || "Error desconocido");
      } finally {
        setLoading(false);
      }
    };

    loadIframe();
  }, [accessToken, shortLink, fallbackUrl, routeId,scene]);

  if (loading) {
    return <div className="evaluacion-iframe">Cargando sala...</div>;
  }

  if (error) {
    return (
      <div className="evaluacion-iframe">
        <p>Error al cargar la sala: {error}</p>
      </div>
    );
  }

  return (
    <div className="evaluacion-iframe">
      <iframe
        src={iframeUrl || ""}
        className="evaluacion-iframe"
        allow="microphone; camera; vr; xr-spatial-tracking; speaker;"
        title="Evaluación"
        style={{ width: "100%", height: "100%", border: "none" }}
      />
    </div>
  );
}
